export const API_BASE = import.meta.env.VITE_API_BASE as string ?? 'http://localhost:5244'
